import React, { useState } from 'react';
import './DeliveryList.css';

const Automail = () => {
    const [client, setClient] = useState('');
    const [fromDate, setFromDate] = useState('2025-07-01');
    const [toDate, setToDate] = useState('2025-07-14');
    const [search, setSearch] = useState('');
    const [attachment, setAttachment] = useState(false);

    const [data, setData] = useState([
        // Dummy example data
        {
            bookDate: '2025-07-01',
            cnoteNo: 'CN001',
            consignee: 'John Enterprises',
            destination: 'Delhi',
            qty: 3,
            forwardingNo: 'FW001',
            Vendor_Name: 'DHL',
            status: 'Pending',
            Delv_Date: "14/07/2025"
        },
        {
            bookDate: '2025-07-03',
            cnoteNo: 'CN002',
            consignee: 'XYZ Traders',
            destination: 'Mumbai',
            qty: 2,
            Vendor_Name: 'BLUEDART',
            forwardingNo: 'FW001',
            status: 'Pending',
            Delv_Date: "15/07/2025"
        },
    ]);

    return (
        <div className="delivery-container">
            <div className="filter-bar">
                <label>Client Name</label>
                <select
                    value={client}
                    onChange={e => setClient(e.target.value)}
                    className="client-select"
                >
                    <option value="">-- Select --</option>
                    <option value="Client A">Client A</option>
                    <option value="Client B">Client B</option>
                    <option value="Client C">Client C</option>
                    <option value="Client D">Client D</option>
                    <option value="Client E">Client E</option>
                    <option value="Client F">Client F</option>
                    <option value="Client G">Client G</option>
                    <option value="Client H">Client H</option>
                    <option value="Client I">Client I</option>
                    <option value="Client J">Client J</option>
                </select>


                <label>From Date</label>
                <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />

                <label>To Date</label>
                <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />

                <label>Search</label>
                <input type="text" value={search} onChange={e => setSearch(e.target.value)} />

                <label>
                    <input type="checkbox" checked={attachment} onChange={e => setAttachment(e.target.checked)} />
                    Attachment
                </label>

                <button className="btn-export">To Export</button>
            </div>

            <table className="delivery-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Book Date</th>
                        <th>CNote No</th>
                        <th>Consignee Name</th>
                        <th>Origin_Name</th>
                        <th>Destination Name</th>
                        <th>Qty</th>
                        <th>Vendor_Name</th>
                        <th>Forwarding No</th>
                        <th>Status</th>
                        <th>Delv_Date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((entry, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{entry.bookDate}</td>
                            <td>{entry.cnoteNo}</td>
                            <td>{entry.consignee}</td>
                            <th>Destination Name</th>
                            <td>{entry.destination}</td>
                            <td>{entry.qty}</td>
                            <td>{entry.Vendor_Name}</td>
                            <td>{entry.forwardingNo}</td>
                            <td>{entry.status}</td>
                            <td>{entry.Delv_Date}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Automail;
